import { http } from "msw";

import { MESSAGE_TYPE } from "@/domains/messages/models/constants";
import { POST_SURVEY_DESTINATION } from "@/domains/surveys/models/constants";
import { appendMessage } from "@/mocks/handlers/messages";
import { withSession } from "@/mocks/resolvers";
import { errorResponse, successResponse } from "@/mocks/responses";

export const createSurveyHandlers = (webappUrl: string) => {
  return [
    http.get(
      `${webappUrl}/survey`,
      withSession(({ state }) => {
        if (!state.careplan) {
          return errorResponse({
            status: 404,
            code: "survey_not_found",
            message: "There is no check-in to complete right now.",
          });
        }

        return successResponse([
          ["FirstName", state.profile.firstName],
          ["CareplanId", String(state.careplan.current.id)],
          ["CareplanVersion", String(state.careplan.current.version)],
        ]);
      }),
    ),

    http.get(
      `${webappUrl}/survey/check/completion`,
      withSession(({ state }) => {
        if (state.pendingActions.length > 0) {
          state.pendingActions = [];
          appendMessage(state, { type: MESSAGE_TYPE.EVENT, content: "Check-in completed" });
        }

        return successResponse({
          destination: state.careplan?.progressEnabled
            ? POST_SURVEY_DESTINATION.PROGRESS
            : POST_SURVEY_DESTINATION.CAREPLAN,
        });
      }),
    ),
  ];
};
